import React from 'react'
import { ShowHide } from '../../../ui/record-display'
import EventRow from './views/event-row'
import './views/ccs-event-management.css'

export const EventDisplay = ({ events }) => {
  if (events.length === 0) return null

  return (
    <ShowHide label="events" className="event-info">
      <div className="event-wrapper">
        {events.map((event) => (
          <EventRow key={event.event_id} event={event}/>
        ))}
      </div>
    </ShowHide>
  )
}



// WEBPACK FOOTER //
// ./src/gov-registrations/details/events-management/index.js